module.exports = function() {    
    const timelineProgressBar = document.querySelector('.timeline-progress-bar');

    if( !timelineProgressBar ) {
        return;
    }

    document.addEventListener("DOMContentLoaded", function(event) { 
        window.addEventListener('scroll', updateProgressBarStatus);
        updateProgressBarStatus();
    });

    
    function updateProgressBarStatus() {
        timelineProgressBar.style.height = getProgressBarStatus() + '%'
    }

    function getProgressBarStatus() {
        const viewportHeight = window.innerHeight;
        const scrollTop = window.scrollY;
        const elementOffsetTop = timelineProgressBar.getBoundingClientRect().top + 200;
        const elementHeight = timelineProgressBar.offsetHeight;
        // Calculate the percentage of the element currently in th viewport
        const distance = scrollTop + viewportHeight - elementOffsetTop;
        const percentage = Math.round(
            distance / ((viewportHeight + elementHeight) / 100)
        );
        return Math.min(100, Math.max(0, percentage));
    }
    
}